// extracted by mini-css-extract-plugin
module.exports = {"main-component":"selectedTaskButton_main-component__TPCSz"};